import * as React from 'react';

import { useSelector } from 'react-redux';
import { BottomFloat } from '../../components/LandingPageV2/BottomFloat';
import { FlightHeader, Header } from '../../components/LandingPageV2/Header';
import { LandingPageLayout } from '../../components/LandingPageV2/LandingPageLayout';
import { CONSULTING_FORM_SUBMITTED_COOKIE_NAME, FORM_ANCHOR } from '../../constants/requestForm';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { useIsWebView } from '../../hooks/useIsWebView';
import { selectFlightEnabled } from '../../selectors/meta';
import { setAnimationAvailable, setExtraHash, setFormStep } from '../../slices';

import { EFormStep } from '../../types/requestForm/requestFormV2';
import { getCookie } from '../../utils/cookie';
import { AdvantagesContainer } from '../AdvantagesContainer';
import { ContactsControls } from '../ContactsControls';
import { ContactsModalV2Container } from '../ContactsModalWindow';
import { HowItWorksContainer } from '../HowItWorksContainer';
import { QuestionsAndAnswersContainer } from '../QuestionsAndAnswersContainer';
import { RequestFormV2Container } from '../RequestFormV2Container';

export const LandingPageV2Container: React.FC = () => {
  const dispatch = useAppDispatch();
  const isFlightEnabled = useSelector(selectFlightEnabled);
  const [isHeaderControlsVisible, setIsHeaderControlsVisible] = React.useState(true);
  const [isFormVisible, setIsFormVisible] = React.useState(false);
  const HeaderComponent = isFlightEnabled ? FlightHeader : Header;

  const isWebView = useIsWebView();

  React.useEffect(() => {
    const hash = window.location.hash;

    if (hash) {
      const anchor = hash.substring(1);
      const isFormAlreadySend = getCookie(CONSULTING_FORM_SUBMITTED_COOKIE_NAME);

      if (anchor === FORM_ANCHOR && !isFormAlreadySend) {
        dispatch(setAnimationAvailable(false));
        dispatch(setExtraHash('#form'));
        dispatch(setFormStep(EFormStep.Contacts));
      }

      const el = document.getElementById(anchor);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }, [dispatch]);

  return (
    <div data-testid={isFlightEnabled ? 'landingPageFlight' : 'landingPageV2'}>
      <HeaderComponent
        setIsHeaderControlsVisible={setIsHeaderControlsVisible}
        controls={
          <ContactsControls
            placement="header"
            phoneDataTestId="ContactsHeaderButton"
            requestFormDataTestId="RequestFormButton"
          />
        }
      />
      <LandingPageLayout isWebView={isWebView}>
        <AdvantagesContainer />
        <HowItWorksContainer />
        <RequestFormV2Container setIsFormVisible={setIsFormVisible} />
        <QuestionsAndAnswersContainer />
      </LandingPageLayout>
      <BottomFloat isVisible={!isHeaderControlsVisible && !isFormVisible}>
        <ContactsControls
          placement="bottomFloat"
          phoneDataTestId="ContactsStickButton"
          requestFormDataTestId="RequestFormStickButton"
        />
      </BottomFloat>
      <ContactsModalV2Container />
    </div>
  );
};
